import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { ModalidadeGarantiaComponent } from "./modalidade-garantia.component";


const routes: Routes = [
    {
        path: 'modalidade-garantia',
        component: ModalidadeGarantiaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false },
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ModalidadeGarantiaRoutingModule {}
